import { renderDate } from '../utility/personTabGridHelper';

export const EMPLOYEE_GRID_COLUMNS = [
  {
    field: 'FullName',
    headerName: 'Full Name',
    width: 200,
    valueGetter: (params) => params.row.PersonInfo?.FullName ?? '',
  },
  {
    field: 'FirstName',
    headerName: 'First Name',
    width: 160,
    valueGetter: (params) => params.row.PersonInfo?.FirstName ?? '',
  },
  {
    field: 'LastName',
    headerName: 'Last Name',
    width: 160,
    valueGetter: (params) => params.row.PersonInfo?.LastName ?? '',
  },
  { field: 'Position', headerName: 'Position', width: 150 },
  { field: 'Rank', headerName: 'Rank', width: 150 },
  { field: 'Hired', headerName: 'Hired', width: 150, valueFormatter: renderDate },
  { field: 'Terminated', headerName: 'Terminated', width: 150, valueFormatter: renderDate },
  { field: 'Created', headerName: 'Created', width: 180, valueFormatter: renderDate },
  { field: 'CreatedBy', headerName: 'Created By', width: 160 },
  { field: 'Updated', headerName: 'Updated', width: 180, valueFormatter: renderDate },
  { field: 'UpdatedBy', headerName: 'Updated By', width: 160 },
];
